let MainPath = process.env.REACT_APP_MAINPATH;

export const paths = {
  MainSlider: `${MainPath}TouristAttraction/Photo/`,
  ProjectPhoto: `${MainPath}NationalProject/Photo/`,
  ProjectAttachment: `${MainPath}NationalProject/Attachment/`,
  ProjectPhotos: `${MainPath}PhotoLibraryPhoto/Photo/`,
  PhotoLibraryAlbum: `${MainPath}PhotoLibrary/Photo/`,
  ImportantPortalsPhotos: `${MainPath}WebLink/Photo/`,
  NewsPhotos: `${MainPath}News/Photo/`,
  DocumentLibraryPhotos: `${MainPath}Document/Photo/`,
  DocumentLibrarAttachment: `${MainPath}Document/Attachment/`,
  FamousPeople: `${MainPath}StaticContent/Photo/`,
  WebLink: `${MainPath}WebLink/Photo/`,
  Governer: `${MainPath}Governor/Photo/`,
  Leader: `${MainPath}Leader/Photo/`,
  Appointment: `${MainPath}Appointment/Photo/`,
  NavBarCities: `${MainPath}City/Photo/`,
  ParliamentPhotos: `${MainPath}StaticContent/Photo/`,
  SenatePhotos: `${MainPath}StaticContent/Photo/`,
  ads: `${MainPath}Advertisment/Photo/`,
  youth: `${MainPath}YouthEmployent/photo/`,
  youthAttachment: `${MainPath}YouthEmployent/Attachment/`,
  careerPhoto: `${MainPath}Career/Photo/`,
  careerAttachment: `${MainPath}Career/Attachment/`,
  TouristAttractionSlider: `${MainPath}PhotoLibraryPhoto/Photo/`,
  EventsPhotos: `${MainPath}Event/Photo/`,
  EventAttachment: `${MainPath}Event/Agenda/`,
  InvestmentPhotos: `${MainPath}Investment/Photo/`,
  StaticContent: `${MainPath}StaticContent/Photo/`,
  OrgChart: `${MainPath}Leader/Photo/`,
  AdsAttachment: `${MainPath}Advertisment/Attachment/`,
  ServicesPhoto: `${MainPath}Services/Photo/`,
  NationalCouncil: `${MainPath}NationalCouncil/Photo/`,
  Directory: `${MainPath}Directory/Photo/`,
  DirectoratePhoto: `${MainPath}Plan/Photo/`,
  DirectorateAttachment: `${MainPath}Plan/Attachment/`,
  LeaderAttachment: `${MainPath}Leader/Resume/`,
  GovernerAttachment: `${MainPath}Governor/Resume/`,
  DirectorateLogo: `${MainPath}Directorate/Logo/`,
  DirectorateResumee: `${MainPath}Directorate/Resumee/`,
};
